import api from '../api';

const listBeneficiaries = () => api.get('/api/beneficiary-types/');

export default {
  listBeneficiaries,
};
